module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  if( alignRightBI.contains(factoryKey) ){ 
    ; __append("\r\n    <div style=\"float: right;\">\r\n")
    ; }else if(isMultipleSelection){
    ; __append("\r\n    <div style=\"float: right;\">\r\n")
    ; }else if(factoryKey === 'control_checkbox' || factoryKey ==='control_radio_button' || factoryKey === 'control_link'){
    ; __append("\r\n    <div style=\"float:right;padding: 13px 0 0 0\">\r\n")
    ; }else if(factoryKey === 'control_drop_down'){
    ; __append("\r\n    <div style=\"float: right;\">\r\n")
    ; }else{
    ; __append("\r\n    <div class=\"col-md-13\" style=\"padding-top:13px\">\r\n")
    ; }
    ; __append("\r\n    <img id=\"boldText\" name=\"textWeight\" title=\"Bold\" src=\"")
    ; __append( require('editor/icons/bold-23.png') )
    ; __append("\" style=\"width: 20px; height: 20px; background-color: ")
    ; __append(escapeFn( boldSelection ))
    ; __append("\" />\r\n    <img id=\"italicText\" name=\"textStyle\" title=\"Italic\" src=\"")
    ; __append( require('editor/icons/italic-23.png') )
    ; __append("\"  style=\"width: 20px; height: 20px; background-color: ")
    ; __append(escapeFn( italicSelection ))
    ; __append("\" />\r\n</div>")
  }
  return __output;

}